import { Fragment, useRef } from 'react';
import {useNavigate} from "react-router-dom";
import { useResizeDetector } from 'react-resize-detector';
import FontBody1 from '../../../fonts/font-body1/font-body1';
import FontHeading1 from '../../../fonts/font-heading1/font-heading1';
import FontHeading2 from '../../../fonts/font-heading2/font-heading2';
import { FONT_COLOR, FONT_VARIANT } from '../../../fonts/font-props';
import './page-title.scss';
import IconBack from '../../../icons/icon-back/icon-back';
import {ButtonIcon} from "../../../inputs/button-icon/button-icon";
import { isSet } from '../../../../models/model-types-methods';

export interface PageTitleProps {
    title: string;
    subTitles?: (string | undefined)[];
    subTitleActions?: React.ReactNode;
    instruction?: React.ReactNode;
    titleActions?: React.ReactNode;
    onHeightChange: (height: number) => void,
    hasBack?: boolean;
    backButtonCallback?: () => void;
}

const Gap = () => (
    <span className="page-title-gap">•</span>
)

const PageTitle: React.FC<PageTitleProps> = ({ title, subTitles = [], subTitleActions, instruction, titleActions, onHeightChange, hasBack, backButtonCallback }) => {
    const titleRef = useRef<HTMLDivElement>(null);

    useResizeDetector<HTMLDivElement>({
        targetRef: titleRef,
        onResize: ({ height }) => {
            if (isSet(height)) {
                onHeightChange(height);
            }
        },
    });
    const navigate = useNavigate();
    const onBackButtonClick = () => {
        if (backButtonCallback) {
            backButtonCallback();
        } else {
            navigate(-1);
        }
    }

    return (
        <>
            <div className="page-title" ref={titleRef}>
                <div className='main-text'>
                    {hasBack ? <div className="page-title-back"><ButtonIcon Component={IconBack} onClick={onBackButtonClick} /></div> : ''}
                    <FontHeading1 variant={FONT_VARIANT.BOLD}>{title}</FontHeading1>
                    {titleActions}
                    {subTitles.map((subTitle, i) => (
                        <Fragment key={i}>
                            <Gap />
                            <FontHeading2 key={i}>{subTitle}</FontHeading2>
                        </Fragment>
                    ))}
                    {subTitleActions && (
                        <div className="page-title-subtitle-actions">{subTitleActions}</div>
                    )}
                </div>
            </div>
            {instruction &&
                <div className='instruction'>
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>{instruction}</FontBody1>
                </div>
            }
        </>
)};

export default PageTitle;
